<template>
  <div class="d-flex pa-2 full-width overflow-hidden" v-on="$listeners">
    <v-avatar class="mt-3" color="#F4F7FA" size="80">
      <!-- <v-icon size="50">mdi-folder-open</v-icon> -->
      <v-img src="/static/img/workspace_img.jpg"> </v-img>
    </v-avatar>
    <div class="pl-sm-4 overflow-hidden">
      <div class="font-weight-bold text-h5 text-truncate" :title="item.name">
        <span>{{ item.name }}</span>
      </div>
      <div
        class="pt-2 pb-1 d-flex align-center full-width"
        :title="item.updated_at | calcDate"
      >
        <span class="text-truncate">
          {{ $t('workspace.modified') }}
          <strong>{{ item.updated_at | calcDate }}</strong>
        </span>
      </div>
      <slot />
      <WorkspaceKeyRequest v-if="current_user_role == 3" :workspace="workspace"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import WorkspaceKeyRequest from './workspace-key-request.vue'
export default {
  components: {
    WorkspaceKeyRequest
  },
  props: {
    value: { type: Object, require: true, default: () => ({}) },
  },
  data: (vm) => ({
    current_user_role: 0,
    workspace: {
      loading: false,
      items: [],
    },
  }),
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    item() {
      return this.value
    },
  },
  created() {
    this.getRole()
    this.workspace.items = [this.item]
  },
  methods: {
    getRole() {
      for (var i = 0; i < this.currentUser.roles.length; i++) {
        if (this.currentUser.roles[i].name == 'Quản Trị Hệ Thống') {
          this.current_user_role = 1
          break
        }
        if (this.currentUser.roles[i].name == 'Biên tập') {
          this.current_user_role = 2
          break
        }
        if (
          this.currentUser.roles[i].name ==
          'Phát triển các ứng dụng, phần mềm khác'
        ) {
          this.current_user_role = 3
        }
      }
    },

  },
}
</script>

<style scoped></style>
